import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';
import Form from '../../common_nextgen/common_components/form/Form';
import { useToast } from '../../common_nextgen/hooks/ToastContext';
import { PRICE_SCHEDULE_MODES, ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import {
    isAddMode,
    isEditMode,
    isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from './BenefitMaxDrugStatusScheduleFormConfig';

const screenInfo = {
    ADD: ['Add Benefit Max Drug Status Schedule', 'RCBMD002'],
    CHANGE: ['Benefit Max Drug Status Schedule Detail', 'RCBMD003'],
};

const BenefitMaxDrugStatusScheduleForm = ({ mode,hideModal }) => {
    const location = useLocation();
    const { state: stateVal } = location;
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    console.log("current state in form", currentState, previousState);
    const {
        selectedSchedules = [],
        previousScreen = ROUTE_PATHS.BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
        currentIndex: initialIndex = 0,
    } = currentState;
    const navigateToPage = useCustomNavigate();
    const [selectedOption, setSelectedOption] = useState('no');
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const [currentMode, setCurrentMode] = useState(mode);
    const [initialFormData, setInitialFormData] = useState({});
    const [dataForSubmission, setDataForSubmission] = useState({});
    const [constraintErrors, setConstraintErrors] = useState([]);
    const toast = useToast();
    const { axios_helper_no_header } = useAxios();

    const lastScheduleName =
    selectedSchedules[currentIndex]?.bmdScheduleCode || "";
  const updatedParamsData = {
    ...currentState.paramsData,
    bmdScheduleCode: lastScheduleName,
    hiddenRecordIndicator:"Active" 
  };

    const handleBack = () => {
        if (currentIndex < selectedSchedules.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setCurrentMode(mode);
        } else {
            navigateToPage(previousScreen, [
                ...previousState,
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
             
            ]);
        }
    };

    const getPageTitle = () => {
        const [screenTitle, screenNumber] = isAddMode(mode) ? screenInfo.ADD : screenInfo.CHANGE;
        return (
            <>
                <span className="title">{screenTitle}</span>
                <span>{'-'}</span>
                <span className="screen-number">{screenNumber}</span>
            </>
        );
    };

    const submitFormData = (data) => {
        setDataForSubmission(data);
    };

    const submitForm = async (dataForSubmission) => {
        let url = '';
        let verb = '';
        let screenNumber = '';

        if (isAddMode(currentMode)) {
            url = 'api/bmdBenMaxDrugStsSch';
            verb = 'POST';
            screenNumber = screenInfo.ADD[1];
        } else {
            url = 'api/bmdBenMaxDrugStsSch';
            verb = 'PUT';
            screenNumber = screenInfo.CHANGE[1];

            if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {
                toast.current.show({ severity: 'info', summary: '', detail: 'No Change of Information', life: 3000 });
                return;
            }
        }

        const data = { ...dataForSubmission, screenNumber };

        try {
            const { responseStatus, responseData } = await axios_helper_no_header(verb, url, data, null);
            setInitialFormData(responseData);
            toast.current.show({ severity: 'success', summary: '', detail: responseStatus.message, life: 3000 });
            if (isAddMode(currentMode)) {
                setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
                const updatedCurrentState = {
                    ...currentState,
                    selectedSchedules: [{ ...responseData }],
                    currentIndex: 0,
                };
                navigateToPage(ROUTE_PATHS.EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE, [
                    ...previousState,
                    { ...updatedCurrentState },
                ]);
            }
        } catch (error) {
            const { responseStatus: { displayErrorFields = null, message } = {} } = error.data;
            if (displayErrorFields === null) {
                toast.current.show({ severity: 'error', summary: '', detail: message, life: 3000 });
            } else {
                setConstraintErrors(displayErrorFields);
            }
        }
    };

    const [keyFunc, keyName] = useMemo(() => {
        const keyFunc = {};
        const keyName = {};

        if (isAddMode(currentMode)) {
            keyFunc.F12 = handleBack;
            keyName.F12 = 'Back';
        } else if (isEditMode(currentMode)) {
            keyFunc.F12 = handleBack;
            keyName.F12 = 'Back';
            keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
            keyName.chmod = 'View';
            keyFunc.F7 = () =>
                navigateToPage('/drug-status-schedule',
                    [
                        ...previousState,
                        { ...currentState, currentIndex },
                        {
                            selectedSchedules: [selectedSchedules[currentIndex]],
                            selectedDescriptions: [selectedSchedules[currentIndex]],
                            currentIndex: 0,
                            previousScreen: location.pathname,
                        },
                    ]);
            keyName.F7 = 'Drug Status';
        } else if (isReadOnlyMode(currentMode)) {
            keyFunc.F12 = handleBack;
            keyName.F12 = 'Back';
            keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
            keyName.chmod = 'Edit';
            keyFunc.F7 = () => navigateToPage('/drug-status-schedule',
                [
                    ...previousState,
                    { ...currentState, currentIndex },
                    {
                        selectedSchedules: [selectedSchedules[currentIndex]],
                        selectedDescriptions: [selectedSchedules[currentIndex]],
                        currentIndex: 0,
                        previousScreen: location.pathname,
                    },
                ]);
            keyName.F7 = 'Drug Status';
        }

        return [keyFunc, keyName];
    }, [currentMode, currentIndex]);

    useEffect(() => {
        const fetchInitialData = async () => {
            const url = isAddMode(currentMode)
                ? 'api/bmdBenMaxDrugStsSch/initialFormData/' + screenInfo.ADD[1]
                : 'api/bmdBenMaxDrugStsSch/' + encodeURIComponent(selectedSchedules[currentIndex].bmdScheduleCode);
            const { responseData } = await axios_helper_no_header('GET', url);
            setInitialFormData(responseData);
        };

        fetchInitialData();
    }, [mode, currentIndex]);

    return (
        <div className="grid container">
            <div className="col col-12">
                <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
            </div>
            <div className="col col-12">
                <h1>{getPageTitle()}</h1>
            </div>
            <div className="col col-12">
                <Form
                    formData={initialFormData}
                    formFields={formFields}
                    mode={currentMode}
                    submitFormData={submitForm}
                    constraintErrors={constraintErrors}
                    hideModal={hideModal}
                />
            </div>
        </div>
    );
};

export default BenefitMaxDrugStatusScheduleForm;  